import { formatBytes } from "./format.ts";

const UNSAFE_NAME_CHARACTERS = /[<>:"/\\|?*\u0000-\u001f\u007f]/g;
const MAX_NAME_LENGTH = 180;

const TEXTUAL_MIME_TYPES = new Set([
  "application/json",
  "application/xml",
  "application/javascript",
  "application/x-yaml",
  "application/yaml",
  "application/toml",
  "application/sql",
  "application/x-sh",
]);

export function outputFileName(path: string): string {
  const segments = path.split("/").filter((segment) => segment.length > 0 && segment !== "." && segment !== "..");
  const base = segments.length > 0 ? segments[segments.length - 1] ?? "" : "";
  const cleaned = base.replace(UNSAFE_NAME_CHARACTERS, "_").replace(/[. ]+$/, "");
  const trimmed = cleaned.slice(0, MAX_NAME_LENGTH);
  return trimmed.length === 0 ? "output" : trimmed;
}

export function outputSizeLabel(size: number): string {
  if (!Number.isFinite(size) || size <= 0) return "0 bytes";
  return formatBytes(size);
}

export function outputKindLabel(mimeType: string): string {
  if (mimeType.startsWith("image/")) return "Image";
  if (mimeType.startsWith("text/")) return "Text";
  if (TEXTUAL_MIME_TYPES.has(mimeType)) return "Text";
  return "Binary";
}

export function outputTotalSizeLabel(outputs: readonly { readonly size: number }[]): string {
  return outputSizeLabel(outputs.reduce((total, output) => total + (Number.isFinite(output.size) ? output.size : 0), 0));
}
